import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
/*
“Bei der Vegetationsfläche werden unbewohnte, vegetationslose Flächen (Seen, Gletscher, Fels) an der Gesamtfläche abgezogen und nicht dargestellt, womit eine realitätsnähere Raumdarstellung für die meisten statistischen Ergebnisse erreicht wird. Die Grundlagen zur Vegetationsfläche stammen von GEOSTAT (BFS) und wurden vom Dienst ThemaKart (1996) kartographisch-visuell abgeleitet. Sie bie-ten keinen Anspruch auf eine rechnerische Auswertegenauigkeit und dienen lediglich der Darstellung.”

*/
// https://www.pxweb.bfs.admin.ch/pxweb/de/px-x-1702020000_105/px-x-1702020000_105/px-x-1702020000_105.px
import styled from 'styled-components'
import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { SwissMap } from 'components/ChoroplethMap'
import { useEffect, useState } from 'react'
import ToolTip from 'components/ToolTip/ToolTip'
import { HistoricalChartD3 } from 'components/HistoricalChartD3'
import custom_munis from "../MuniSearchData/20230101_de_filtered.json"

import { ColorKey } from 'components/ChoroplethMap/ColorKey'
import { UserSelection } from 'components/UserSelection'
import { party_names, party_names_long } from './party_colors'
import { Select } from 'components/Select'
import { years } from './constants'
import MunicipalitySearch, {
  Municipality,
} from '@ta-interaktiv/react-municipality-search'

import { useTranslation } from 'react-i18next'
import '../../i18n'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [activeParty, setActiveParty] = useState<string>('Schweiz')
  const [activeYear, setActiveYear] = useState<number>(2023)
  const [activeBfsId, setActiveBfsId] = useState<number | undefined>(0)
  const [activeData, setActiveData] = useState<any>()
  const [activeMunicipality, setActiveMunicipality] = useState<Municipality>()
  const [customMunicipalities, setCustomMunicipalities] = useState<any>([])
  useEffect(() => {
    fetch(
      'https://atm-municipality-search.s3.eu-west-1.amazonaws.com/20230101_de.json'
    )
      .then((a) => a.json())
      .then((a) => {
        setCustomMunicipalities(a)
      })
  }, [])

  const handleYearChange = (value: any) => {
    setActiveYear(value)
  }
  const handlePartyChange = (value: any) => {
    setActiveParty(value)
  }
  const newActiveMunicipalityIdHandler = (value: any) => {
    setActiveBfsId(value)
  }

  const locale: 'de' | 'fr' = 'de'
  const { t, i18n } = useTranslation()

  useEffect(() => {
    i18n.changeLanguage(tenant.lang)
  }, [tenant])

  return (
    <AppContainer $colorMode={colorMode}>
      {/* <TextWidth>
        <p>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
          ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
          sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
          dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam
          et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
          takimata sanctus est Lorem ipsum dolor sit amet.
        </p>
      </TextWidth> */}
      <div
        style={{
          backgroundColor: 'var(--data-background)',
          paddingTop: '15px',
          paddingBottom: '60px',
        }}
      >
        <MapTitle>
          <span className='title'>
            {activeParty === 'Schweiz'
              ? t('swissmap:title:main')
              : t('swissmap:title:varA') +
                t(`swissmap:parties:${party_names_long[activeParty]}`).replace('*', '') +
                t('swissmap:title:varB')}
          </span>
          <span className='sub'>{t('swissmap:subTitle')}</span>
        </MapTitle>
        <SearchWrapper>
          {custom_munis && (
            <MunicipalitySearch
              // customMunicipalities={custom_munis as any}
              locale={i18n.language as 'de' | 'fr'}
              // dedupe
              maxResults={8}
              municipalityData={'20230101_'+ tenant.lang + '_nozip'}
              resetOnSelect
              placeholder={t('swissmap:searchMunicipalityPlaceholder')}
              selectedMunicipality={activeMunicipality}
              onCloseHandler={() => {
                setActiveMunicipality(undefined)
                setActiveBfsId(undefined)
              }}
              onSelectionHandler={(selectedMunicipality: Municipality) => {
                setActiveMunicipality(selectedMunicipality)
                if (newActiveMunicipalityIdHandler) {
                  newActiveMunicipalityIdHandler(selectedMunicipality.GDENR)
                }
              }}
            />
          )}
        </SearchWrapper>

        <SwissMap
          colorMode={colorMode}
          setActiveData={setActiveData}
          LegendComponent={ColorKey}
          setActiveMunicipalityId={(newBfsId?: number)=>{
            newActiveMunicipalityIdHandler(newBfsId) 
            !newBfsId && setActiveMunicipality(undefined)
          }}
          activeMunicipalityId={activeBfsId}
          activeParty={activeParty}
          setActiveParty={setActiveParty}
          activeYear={activeYear}
          setActiveYear={setActiveYear}
          topoJsonYear={2023}
          municipalitySearchYear={'2019'}
          // topoJson={require('../ChoroplethMap/Assets/ch_incl_unprod_95_5.json')}
          ToolTip={ToolTip}
          layerStyles={{
            country: {
              stroke:
                colorMode === 'dark' ? 'rgba(0,0,0,0.8)' : 'rgba(0,0,0,0.3)', // 'var(--gray-3)',
              strokeWidth: '1px',
              fill: 'none',
            },
            unproductive: {
              fill: 'url(#pattern-circles)',
              // stroke: '#fff',
              strokeWidth: '.5px',
              stroke: 'none',
            },
            municipality: {
              strokeWidth: '0.5px',
              stroke:
                activeParty === 'Schweiz'
                  ? 'rgba(0,0,0,.35)'
                  : 'rgba(0,0,0,.2)',
              fill: 'var(--gray-1)',
            },
            municipalityHover: {
              strokeWidth: '0.25px',
              stroke: 'var(--gray-4)',
            },

            lakes: {
              fill: colorMode === 'dark' ? 'var(--gray-2)' : 'var(--gray-4)',
              stroke: 'none',
            },
          }}
        />
        {/* <UserSelection
          colorMode={colorMode}
          locale={locale}
          activeParty={activeParty}
          activeYear={activeYear}
          handlePartyChange={handlePartyChange}
          handleYearChange={handleYearChange}
          handleMunicipalityChange={newActiveMunicipalityIdHandler}
        /> */}
        <TextWidthExtended>
          <MapTitle>
            <span className='title'>
              {activeBfsId === 0 || !activeBfsId
                ? t("swissmap:historicalEvolution")
                : t("swissmap:historicalEvolution") + ' ' +
                  (activeData ? t("swissmap:historicalEvolutionPrep") + activeData.name_de : '')}
            </span>
            <span className='sub'>{t("swissmap:voterShareNationalCouncilPercent")}</span>
          </MapTitle>
          <HistoricalChartD3
          colorMode={colorMode}
            bfsid={activeBfsId}
            activeParty={activeParty}
            activeYear={activeYear}
            setActiveYear={setActiveYear}
            setActiveParty={setActiveParty}
          />
          <Source>
            {t('swissmap:source')}:{' '}
            <a href='https://www.bfs.admin.ch/bfs/de/home/statistiken/politik/wahlen.html'>
              {t('swissmap:federalOfficeForStatistics')}
            </a>{' '}
          </Source>
        </TextWidthExtended>
      </div>
      {/* <TextWidth>
        <p>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
          ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
          sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
          dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam
          et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
          takimata sanctus est Lorem ipsum dolor sit amet.
        </p>
      </TextWidth> */}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-bottom: 60px;
  
`
export default MainComponent

const MapTitle = styled.h3`
  text-align: center;
  margin: 0;
  margin-top: 15px;
  margin-bottom: 15px;
  letter-spacing: 0.5px;
  position: relative;
  @media screen and (max-width: 711px) {
    font-size: 18px;
  }
  span.title {
    font-weight: 700;

    display: inline-block;
    position: relative;

    /* border-top: 1px solid rgba(0, 0, 0, 0.3); */
    padding-top: 30px;
    padding-left: 0;
    padding-right: 0;
    /* -webkit-box-shadow: 0px 15px 15px 5px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 15px 15px 5px rgba(0, 0, 0, 0.1); */
    /* &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 25%;
      height: 4px;
      background-color: var(--text-color);
    } */
  }
  span.sub {
    font-weight: 300;

    line-height: 1em;
    margin: 0;
    display: inline-block;
    width: 100%;
    font-size: 15px;
    opacity: 0.75;
    letter-spacing: 0.2px;
  }
`

const Source = styled.div`
  font-size: 12px;
  color: var(--source-color);
  font-family: var(--font-sans-serif) !important;

  a {
    font-family: var(--font-sans-serif) !important;
    color: var(--source-color) !important;
  }
`
const SearchWrapper = styled.div`
  flex: 0 0 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 90px;
  position: relative;
  flex: 0 0 100%;
  padding: 0 1em;
  z-index: 500;
`
